module.exports = __webpack_public_path__ + "img/img_14.32208968.jpg";